export default "__VITE_ASSET__D1_GT0zM__"